import React, {useState} from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import {NiceModalForm} from "../../components/Modals";
import {callAndReload, matchFormat, pp} from "../../utils";
import GroupsSelector from "../../components/GroupsSelector";
import _ from "lodash";
import {Alert, Form, Radio} from "antd";

export default NiceModal.create(({ division, groups, recommended }) => {
  const [tempGroups, setTempGroups] = useState(_.cloneDeep(groups));

  const modal = useModal();

  let onSave = async (params) => {
    await callAndReload({
      url: '/divisions/' + division.id,
      params: { ...params, gen_pools: true, groups: tempGroups.map(g => g.map(t => t.id)) },
      method: 'put',
    })
  }

  let onDrop = items => {
    setTempGroups(_.cloneDeep(tempGroups));
  }

  let w = tempGroups.length*300

  return <NiceModalForm onSave={onSave} modal={modal} title={"Generate " + division.name + " Pools"}
                        top
                        okText="Generate" width={w || 400}
                        initialValues={{
                          match_format: "to_21",
                          bracket_format: "rr",
                        }}>
    {/*<Alert type="info" message="Recommended:" description={recommended} />*/}
    {/*<br/>*/}
    <Form.Item name="match_format" label="Format" rules={[{ required: true}]}>
      <Radio.Group optionType="button" buttonStyle="solid">
        <Radio value="to_21">{matchFormat("to_21")}</Radio>
        <Radio value="to_15">{matchFormat("to_15")}</Radio>
        {/*<Radio value="to_11">{matchFormat("to_11")}</Radio>*/}
      </Radio.Group>
    </Form.Item>
    <Form.Item name="bracket_format" label="Prelims Style" rules={[{ required: true}]}>
      <Radio.Group optionType="button" buttonStyle="solid">
        <Radio value="rr">RR</Radio>
        <Radio value="dbl_rr">Double RR</Radio>
      </Radio.Group>
    </Form.Item>
    <GroupsSelector groups={tempGroups} onDrop={onDrop}/>
  </NiceModalForm>;
});
